class ExponentialMovingAverage {
  period: number
  multiplier: number
  sum: number
  count: number
  value: number

  constructor(period: number) {
    this.period = period
    this.multiplier = 2 / (this.period + 1)
    this.sum = 0
    this.count = 0
    this.value = 0
  }

  add(d: number) {
    if (this.count < this.period) {
      this.sum += d
      this.count++
      this.value = this.sum / this.count
    } else {
      this.value = d * this.multiplier + this.value * (1 - this.multiplier)
    }
  }
}

export default ExponentialMovingAverage
